import { render, staticRenderFns } from "./AddSubjectForClassDialog.vue?vue&type=template&id=0456f7b1&scoped=true"
import script from "./AddSubjectForClassDialog.vue?vue&type=script&lang=js"
export * from "./AddSubjectForClassDialog.vue?vue&type=script&lang=js"
import style0 from "./AddSubjectForClassDialog.vue?vue&type=style&index=0&id=0456f7b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0456f7b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0456f7b1')) {
      api.createRecord('0456f7b1', component.options)
    } else {
      api.reload('0456f7b1', component.options)
    }
    module.hot.accept("./AddSubjectForClassDialog.vue?vue&type=template&id=0456f7b1&scoped=true", function () {
      api.rerender('0456f7b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/AddSubjectForClassDialog.vue"
export default component.exports